import { MetaData, SubscriptionNumberPage } from '@/components'
import { initializeStore } from '@/store'
import { getAreaInfoById, fetchAreaInfo } from '@/store/slices/stagesSlice/stagesSlice';
import { NextPage } from 'next'

const NextSubscriptionNumberPage: NextPage<{ areaId: string; subscriptionId: string }> = ({
  areaId,
  subscriptionId,
}) => {
  return (
    <>
      <MetaData />
      <SubscriptionNumberPage areaId={areaId} subscriptionId={subscriptionId} />
    </>
  )
}

NextSubscriptionNumberPage.getInitialProps = async ({ query }) => {
  const areaId: string = query.areaId as string
  const subscriptionId: string = query.subscriptionId as string
  const reduxStore = initializeStore()
  const { dispatch, getState } = reduxStore

  const response = getAreaInfoById(getState(), areaId)
  if (!response.data) {
    await dispatch(fetchAreaInfo({ id: areaId }))
  }

  return {
    initialReduxState: reduxStore.getState(),
    areaId,
    subscriptionId,
    headerLayout: 'back',
  }
}

export default NextSubscriptionNumberPage
